import type { TypographyProps } from '@unifyapps/ui/components/Typography';
import type {
  CSSProperties,
  ForwardRefExoticComponent,
  PropsWithChildren,
  ReactElement,
  ReactNode,
  RefAttributes,
} from 'react';

export enum TypographyWithExpandCollapseSlots {
  Expand = 'EXPAND',
  Collapse = 'COLLAPSE',
}

export type SlotProps = {
  name: TypographyWithExpandCollapseSlots;
  id?: string;
  children: ReactNode;
};

export type TypographyWithExpandCollapseProps = {
  text: string;
  children: ReactElement<any>[];
  truncationLabelContainerStyle?: CSSProperties;
} & Pick<
  TypographyProps,
  'align' | 'style' | 'variant' | 'weight' | 'title' | 'className' | 'maxNumberOfLines'
>;

export function Slot(_: PropsWithChildren<SlotProps>): null {
  return null;
}

export type TypographyWithExpandCollapseType = ForwardRefExoticComponent<
  TypographyWithExpandCollapseProps & RefAttributes<HTMLDivElement>
> & {
  Slot: typeof Slot;
};
